import { createSlice } from '@reduxjs/toolkit';


export const getCarrierRatesSlice = createSlice({
  name: 'getCarrierRates',
  initialState: {
    RateValues: {}
  },
  reducers: {
    setRateValues: (state, action) => {
      return action.payload;
    }
  },
  extraReducers: {
    // Extra reducer comes here
  }
});

export const { setRateValues } = getCarrierRatesSlice.actions;
